var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./loading-bar.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-9616b8b0!../../../../vue-loader/lib/selector?type=template&index=0!./loading-bar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/iview/src/components/loading-bar/loading-bar.vue
// module id = 1586
// module chunks = 115